import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.dictType = ''
      this.dictName = ''
      this.status = 0
    }
  }
}
export default searchFrom
